import React from 'react';

import { useConvoContext } from '../convo-context';
import * as Env from 'widget/env';

import { useDate, useIsCollapsed } from './hooks';
import Msg from './msg/msg';
import SystemMessage from './system-message/system-message';

interface Thread {
  message: Env.Message;
}

const Thread = ({ message }: Thread) => {
  const { messageList } = useConvoContext();

  const date = useDate(message, messageList);
  const isCollapsed = useIsCollapsed(message, messageList);

  return (
    <>
      {date && <SystemMessage>{date}</SystemMessage>}
      <Msg isCollapsed={isCollapsed} key={message.id} msg={message} />
    </>
  );
};

export default Thread;
